export const FILLABLE_ELEMENTS_MAIN_CONTENT = {
  CHECK_BOX_TEXT: {
    key: 'CHECK_BOX_TEXT',
    value: 'Check Box',
  },
  RADIO_BUTTON_TEXT: {
    key: 'RADIO_BUTTON_TEXT',
    value: 'Radio Button',
  },
  TEXT_BOX_TEXT: {
    key: 'TEXT_BOX_TEXT',
    value: 'Placeholder text',
  },
  SIGNATURE_TEXT: {
    key: 'SIGNATURE_TEXT',
    value: 'Sign Here',
  },
  COMBO_BOX_TEXT: {
    key: 'COMBO_BOX_TEXT',
    value: 'Value',
  },
};
